import { useEffect, useState } from 'react'
import { checkFaceidRequired } from '../../api/orderService'

interface UseFaceIdGrayControlResult {
  shouldUseFaceId: boolean
}

export default function useFaceIdGrayControl(linkId: string): UseFaceIdGrayControlResult {
  const [shouldUseFaceId, setShouldUseFaceId] = useState(false)

  useEffect(() => {
    if (!linkId) return
    checkFaceidRequired(linkId)
      .then((result) => {
        setShouldUseFaceId(result)
      })
      .catch(() => {
        setShouldUseFaceId(false)
      })
  }, [linkId])

  return {
    shouldUseFaceId,
  }
}
